module.exports = __webpack_public_path__ + "static/assets/62ba2cbe1bb712dbb8023b4f4297d7a6.gif";